import { mutationTypes } from 'BASE/store/types'
import CONSTANT from 'BASE/common/chat/chat.constant'
import transform from 'BASE/common/chat/chat.transformServerName'
import * as model from 'BASE/store/chat/chat.store.model'

export default class {
    constructor() {
        this[mutationTypes.CHAT_INIT_DATA] = (state, payload) => {
            let result = payload.result;
            let hasChatExternalLink = payload.hasChatExternalLink ? payload.hasChatExternalLink : false;
            let excludeIsChatDenied = payload.excludeIsChatDenied ? payload.excludeIsChatDenied : false;

            state.hasChatExternalLink = hasChatExternalLink;
            state.excludeIsChatDenied = excludeIsChatDenied;

            state.isConnected = true;

            state.userId = result.HashUserId;
            state.loginId = result.LoginId;
            state.nickName = result.NickName;
            state.userLevel = result.UserLevel;
            state.headImage = result.HeadImage;
            state.customerServiceRating.sessionId = result.CustomerServiceSessionId;
            state.isSiteGroupTutor = result.IsSiteGroupTutor;

            let resultRooms = result.Rooms
                .concat(result.SiteGroupRooms || [])
                .concat(result.SiteGroupTutorRecentRooms || []);
            resultRooms.forEach(item => {
                const room = transform.transformRoom(item);
                const members = item.Members ? item.Members.map(m => transform.transformRoomMember(m)) : undefined;
                const lastMessage = item.LastMessage ? transform.transformRoomMessage(item.LastMessage) : undefined;
                
                // SiteGroupTutorRecentRooms是近期導師聊天室，會加入訊息清單
                if (room.type === CONSTANT.roomType.SITE_GROUP_TUTOR) {
                    room.startTutorTalking = true;
                }

                this.addRoom(state, room, members, lastMessage);
            });

            state.reconnectedSyncTime = new Date();
        };

        this[mutationTypes.CHAT_SET_CONNECTION_STATE] = (state, payload) => {
            let isConnected = payload.isConnected;
            state.isConnected = isConnected;
        };

        this[mutationTypes.CHAT_UPDATE_RECONNECTED_SYNC_TIME] = (state) => {
            state.reconnectedSyncTime = new Date();
        };

        this[mutationTypes.CHAT_SET_MULTICASTING] = (state, payload) => {
            let isMulticasting = payload.isMulticasting;
            state.isMulticasting = isMulticasting;
        };

        this[mutationTypes.CHAT_ADD_ROOM_WINDOW] = (state, payload) => {
            let roomId = payload.roomId;
            let roomWindow = state.roomWindows.find((item) => {
                return item.room.id === roomId;
            });
            if (!roomWindow) {
                state.roomWindows.push(new model.roomWindow({
                    room: state.rooms.find((item) => {
                        return item.id === roomId;
                    }),
                    showTime: undefined,
                }));
            }
        };

        this[mutationTypes.CHAT_REMOVE_ROOM_WINDOW] = (state, payload) => {
            let roomId = payload.roomId;
            state.roomWindows = state.roomWindows.filter((item) => {
                return item.room.id !== roomId;
            });
        };

        this[mutationTypes.CHAT_OPEN_ROOM_WINDOW] = (state, payload) => {
            let roomId = payload.roomId;
            let roomWindow = state.roomWindows.find((item) => {
                return item.room.id === roomId;
            });
            if (roomWindow) {
                roomWindow.showTime = new Date();
            }
        };

        this[mutationTypes.CHAT_COLSE_ROOM_WINDOW] = (state, payload) => {
            let roomId = payload.roomId;
            let roomWindow = state.roomWindows.find((item) => {
                return item.room.id === roomId;
            });
            roomWindow.showTime = undefined;
        };

        this[mutationTypes.CHAT_ADD_ROOM_MESSAGE_CONTAINER] = (state, payload) => {
            let roomId = payload.roomId;
            state.roomMessageContainers.push(new model.roomMessageContainer({
                room: state.rooms.find((item) => {
                    return item.id === roomId;
                }),
                roomMessages: [],
            }));
        };

        this[mutationTypes.CHAT_REMOVE_ROOM_MESSAGE_CONTAINER] = (state, payload) => {
            let roomId = payload.roomId;
            state.roomMessageContainers = state.roomMessageContainers.filter((item) => {
                return item.room.id !== roomId;
            });
        };

        this[mutationTypes.CHAT_ADD_ROOM_MESSAGE] = (state, payload) => {
            let roomId = payload.roomId;
            let messageId = payload.messageId;
            let userId = payload.userId;
            let type = payload.type;
            let name = payload.name;
            let content = payload.content;
            let timestampStr = payload.timestamp;
            let userLevel = payload.userLevel;
            let headImage = payload.headImage;

            if (!content || content === "") {
                return;
            }

            let messageContainer = state.roomMessageContainers.find((item) => {
                return item.room.id === roomId;
            });
            if (messageContainer) {
                let messages = messageContainer.roomMessages;
                let timestamp = timestampStr ? new Date(timestampStr) : undefined;
                if (!timestamp) {
                    if (messages.length > 0) {
                        timestamp = messages[messages.length - 1].timestamp;
                        timestamp.setMilliseconds(timestamp.getMilliseconds() + 1);
                    } else {
                        // 不能使用本地時間, 所以使用初始時間
                        timestamp = new Date(0);
                    }
                }

                let memberContainer = state.roomMemberContainers.find((item) => item.room.id === roomId);
                let member = (memberContainer && memberContainer.roomMembers) ?
                    memberContainer.roomMembers.find((item) => item.userId === userId) : undefined;
                let isMyself = userId === state.userId;

                let i = 0;
                for (i = messages.length - 1; i >= 0; i--) {
                    if (messageId && messageId === messages[i].messageId) {
                        return;
                    }
                    if (timestamp >= messages[i].timestamp) {
                        break;
                    }
                }
                messages.splice(i + 1, 0, new model.roomMessage({
                    messageId: messageId,
                    userId: userId,
                    type: type,
                    name: this.getMessageName(state, memberContainer.room, member, isMyself, name),
                    content: content,
                    timestamp: timestamp,
                    userLevel: userLevel,
                    headImage: this.getHeadImage(state, member, isMyself, headImage),
                }));
            }
        };

        this[mutationTypes.CHAT_REMOVE_ROOM_MESSAGE] = (state, payload) => {
            let roomId = payload.roomId;
            let messageId = payload.messageId;

            let messageContainer = state.roomMessageContainers.find((item) => {
                return item.room.id === roomId;
            });
            if (messageContainer) {
                messageContainer.roomMessages = messageContainer.roomMessages.filter(item => {
                    return item.messageId !== messageId;
                });
            }
        };

        this[mutationTypes.CHAT_UPDATE_ROOM_MESSAGE_SEND_TIME] = (state, payload) => {
            let roomId = payload.roomId;
            let timestamp = payload.timestamp;
            let room = state.rooms.find((item) => item.id === roomId);
            if (room) {
                room.messageSendTime = timestamp;
            }
        };

        this[mutationTypes.CHAT_REMOVE_ROOM_MESSAGE_BY_CLEAR_TIME] = (state, payload) => {
            let roomId = payload.roomId;
            let timestamp = payload.timestamp;
            let thresholdTime = new Date(timestamp);

            let hasCustomerServiceQuestionList = false;
            let messageContainer = state.roomMessageContainers.find((item) => item.room.id === roomId);
            if (messageContainer) {
                messageContainer.roomMessages = messageContainer.roomMessages.filter((item) => {
                    if (item.timestamp > thresholdTime) {
                        return true;
                    } else if (item.type === CONSTANT.messageType.CUSTOMER_SERVICE_QUESTION_LIST
                        && !hasCustomerServiceQuestionList) {
                        // 客服提問訊息只需出現過一次 其它刪掉
                        hasCustomerServiceQuestionList = true;
                        return true;
                    }
                    return false;
                });
            }
        };

        this[mutationTypes.CHAT_UPDATE_MESSAGE_CLEAR_TIME] = (state, payload) => {
            let roomId = payload.roomId;
            let timestamp = payload.timestamp;
            let room = state.rooms.find((item) => item.id === roomId);
            if (room) {
                room.messageClearTime = new Date(timestamp);
            }
        };

        this[mutationTypes.CHAT_INCREMENT_UNREAD_NUMBER] = (state, payload) => {
            let roomId = payload.roomId;
            let count = payload.count;
            let increment = payload.increment;

            let room = state.rooms.find((item) => {
                return item.id === roomId;
            });
            if (room) {
                if (count !== undefined) {
                    room.unreadCount = count;
                } else if (increment > 0){
                    room.unreadCount += increment;
                }
            }
        };

        this[mutationTypes.CHAT_SET_ROOM_ONLINE_STATE] = (state, payload) => {
            let roomId = payload.roomId;
            let isOnline = payload.isOnline;
            let memberContainer = state.roomMemberContainers.find((item) => {
                return item.room.id === roomId;
            });
            if (memberContainer) {
                switch (memberContainer.room.type) {
                    case CONSTANT.roomType.ANCESTOR:
                    case CONSTANT.roomType.DESCENDANT:
                        memberContainer.roomMembers[0].isOnline = isOnline;
                        break;
                    default:
                        break;
                }
            } else {
                let room = state.rooms.find((item) => {
                    return item.id === roomId;
                });
                if (room) {
                    if (room.type === CONSTANT.roomType.CUSTOMER_SERVICE) {
                        //TODO: JhihPing, change customer service online state
                    }
                }
            }
        };

        this[mutationTypes.CHAT_ADD_ROOM_MEMBER] = (state, payload) => {
            let roomId = payload.roomId;
            let member = payload.member;
            
            let memberContainer = state.roomMemberContainers.find((item) => item.room.id === roomId);
            if (memberContainer) {
                let existedMember = memberContainer.roomMembers.find((item) => item.userId === member.userId);
                if (existedMember) {
                    // NOTICE: 不會給上線狀態 因為已經有不需拿
                    //existedMember.isOnline = member.isOnline;
                    existedMember.role = member.role;
                    existedMember.loginId = member.loginId;
                    existedMember.nickName = member.nickName;
                    existedMember.isChatDenied = member.isChatDenied;
                    existedMember.userLevel = member.userLevel;
                    existedMember.headImage = member.headImage;
                    existedMember.isReadOnly = member.isReadOnly;
                } else {
                    memberContainer.roomMembers.push(member);
                }
            }
        };

        this[mutationTypes.CHAT_REMOVE_ROOM_MEMBER] = (state, payload) => {
            let roomId = payload.roomId;
            let userId = payload.userId;

            let memberContainer = state.roomMemberContainers.find((item) => item.room.id === roomId);
            if (memberContainer) {
                memberContainer.roomMembers = memberContainer.roomMembers.filter((item) => item.userId !== userId);
            }
        };

        this[mutationTypes.CHAT_ADD_ROOM] = (state, payload) => {
            const room = payload.room;
            const members = payload.members;
            const lastMessage = payload.lastMessage
            this.addRoom(state, room, members, lastMessage);
        };

        this[mutationTypes.CHAT_REMOVE_ROOM] = (state, payload) => {
            let roomId = payload.roomId;
            state.roomMemberContainers = state.roomMemberContainers.filter((item) => item.room.id !== roomId);
            state.roomMessageContainers = state.roomMessageContainers.filter((item) => item.room.id !== roomId);
            state.roomWindows = state.roomWindows.filter((item) => item.room.id !== roomId);
            state.roomWindowSizes = state.roomWindowSizes.filter((item) => item.room.id !== roomId);
            state.rooms = state.rooms.filter((item) => item.id !== roomId);
        };

        this[mutationTypes.CHAT_CHANGE_ROOM_NAME] = (state, payload) => {
            let roomId = payload.roomId;
            let roomName = payload.roomName;

            let room = state.rooms.find((item) => item.id === roomId);
            if (room) {
                room.name = roomName;
            }
        };

        this[mutationTypes.CHAT_SET_ANONYMITY_STATE] = (state, payload) => {
            let isAnonymity = payload.isAnonymity;
            state.isAnonymity = isAnonymity;
        };

        this[mutationTypes.CHAT_UPDATE_ROOM_ON_TALK_STATE] = (state, payload) => {
            let roomId = payload.roomId;
            let room = state.rooms.find((item) => item.id === roomId);
            if (room) {
                //如果原本就有打開不變換新的時間，除非新的時間改成undefined
                if(room.onTalkTime && payload.onTalkTime)
                    return;
                
                room.onTalkTime = payload.onTalkTime;
            }
        };

        this[mutationTypes.CHAT_CHANGE_ROOM_ANNOUNCEMENT] = (state, payload) => {
            let roomId = payload.roomId;
            let room = state.rooms.find((item) => item.id === roomId);
            if (room) {
                room.announcement = payload.announcement;
            }
        };

        this[mutationTypes.CHAT_UPDATE_GROUP_ROOM_READONLY] = (state, payload) => {
            let roomId = payload.roomId;
            let groupReadOnly = payload.groupReadOnly;

            let memberContainer = state.roomMemberContainers.find((item) => item.room.id === roomId);
            if (memberContainer) {
                memberContainer.room.groupReadOnly = groupReadOnly; //群組集體禁言顯示

                //找到個人群組禁言狀態和集體禁言，在確認最後個人當前聊天室最終禁言狀態
                let existedMember = memberContainer.roomMembers.find((item) => item.userId === state.userId);
                if (existedMember) {
                    memberContainer.room.isReadOnly = groupReadOnly || existedMember.isReadOnly;
                }
            }
        };

        this[mutationTypes.CHAT_UPDATE_GROUP_ROOM_MEMBER_READONLY] = (state, payload) => {
            let roomId = payload.roomId;
            let member = payload.member;
            let groupReadOnly = payload.groupReadOnly;

            let memberContainer = state.roomMemberContainers.find((item) => item.room.id === roomId);
            if (memberContainer) {
                let existedMember = memberContainer.roomMembers.find((item) => item.userId === member.userId);
                if (existedMember) {
                    existedMember.isReadOnly = member.isReadOnly;

                    //如果是自己群組禁言被變更，需看集體禁言和個人禁言狀態再變更當前聊天室禁言狀態
                    if(existedMember.userId == state.userId){
                        memberContainer.room.isReadOnly = groupReadOnly || existedMember.isReadOnly;
                    }
                }
            }
        };

        this[mutationTypes.CHAT_SET_GROUP_ROOM_MEMBER_ROLE] = (state, payload) => {
            let roomId = payload.roomId;
            let member = payload.member;

            let memberContainer = state.roomMemberContainers.find((item) => item.room.id === roomId);
            if (memberContainer) {
                let existedMember = memberContainer.roomMembers.find((item) => item.userId === member.userId);
                if (existedMember) {
                    existedMember.role = member.role;
                }
            }
        };

        this[mutationTypes.CHAT_UPDATE_LAST_MESSAGE] = (state, payload) => {
            let roomId = payload.roomId;
            let userId = payload.userId;
            let type = payload.type;
            let name = payload.name;
            let content = payload.content;
            let timestampStr = payload.timestamp;
            this.updateLastMessage(state, roomId, userId, type, name, content, timestampStr);
        };

        this[mutationTypes.CHAT_SET_CUSTOMER_SERVICE_SESSION_ID] = (state, payload) => {
            let sessionId = payload.sessionId;
            let isAlreadyRating = payload.isAlreadyRating;
            state.customerServiceRating = {
                sessionId: sessionId,
                isAlreadyRating: isAlreadyRating
            };
        };

        this[mutationTypes.CHAT_SET_ROOM_WINDOW_SIZE] = (state, payload) => {
            let roomWindow = state.roomWindows.find((item) => {
                return item.showTime !== undefined;
            });
            if (roomWindow) {
                let openedWindow = state.roomWindowSizes.find( item => item.room.id === roomWindow.room.id);
                if (openedWindow) {
                    openedWindow.width= payload.width;
                    openedWindow.height= payload.height;
                    openedWindow.date =  new Date();
                } else {
                    state.roomWindowSizes.push(new model.roomWindowSize({
                        room: roomWindow.room,
                        width: payload.width,
                        height: payload.height,
                        date: new Date()
                    }));
                }
            }
        };

        this[mutationTypes.CHAT_UPDATE_DIALOG_PAGE_NAME_AND_DATA] = (state, payload) => {
            state.dialogPage.pageName = payload.pageName;
            // 新值覆蓋舊值
            state.dialogPage.data = Object.assign({}, state.dialogPage.data, payload.data);
        };

        this[mutationTypes.CHAT_SITE_GROUP_INIT_ROOM] = (state, payload) => {
            const roomId = payload.roomId;
            const result = payload.result;
            const tutors = result.Tutors || [];
            state.siteGroupRoom = new model.siteGroupRoom({
                room: state.rooms.find(room => room.id === roomId),
                isReadOnly: result.IsReadOnly,
                systemMessage: result.SystemMessage,
                readOnlyHint: result.ReadOnlyHint,
                isTutor: result.IsTutor,
                pinMessageId: result.PinMessageId
            })
            state.tutors = tutors.map(tutor => {
                return new model.tutor({
                    roomId: tutor.RoomId,
                    name: tutor.Name,
                    headImage: tutor.HeadImage,
                });
            });
        };

        this[mutationTypes.CHAT_SITE_GROUP_UPDATE_ENTER_ROOM_USERNAME] = (state, payload) => {
            if (state.siteGroupRoom) {
                state.siteGroupRoom.enteringUserName = payload.name;
            }
        };

        this[mutationTypes.CHAT_SITE_GROUP_START_TUTOR_TALKING] = (state, payload) => {
            const tutorRoom = state.rooms.find(room => room.id === payload.roomId)
            if (tutorRoom) {
                tutorRoom.startTutorTalking = true;
            }
        };

        this[mutationTypes.CHAT_SITE_GROUP_END_TUTOR_TALKING] = (state, payload) => {
            const tutorRoom = state.rooms.find(room => room.id === payload.roomId)
            if (tutorRoom) {
                tutorRoom.startTutorTalking = false;
            }
        };

        this[mutationTypes.CHAT_SITE_GROUP_UPDATE_TUTOR_MESSAGE_NOTICE_ROOMID] = (state, payload) => {
            state.tutorMessageNoticeRoomId = payload.roomId;
        };

        this[mutationTypes.CHAT_SITE_GROUP_SET_FOLLOW_BET_DATA] = (state, payload) => {
            if (state.siteGroupRoom) {
                state.siteGroupRoom.followBet = payload.bet;
            }
        };

        this[mutationTypes.CHAT_UPDATE_PIN_MESSAGE] = (state, payload) => {
            // 同全站群聊才需置頂訊息
            if (state.siteGroupRoom.room.id === payload.roomId) {
                state.siteGroupRoom.pinMessageId = payload.pinMessageId;
            }
            
            //TODO: Sean 後續如其它Room需置頂訊息可共用此方法，多找出對應的Room在添加
            /*
            let roomId = payload.roomId;
            let room = state.rooms.find((item) => item.id === roomId);
            if (room) {
                room.pinMessageId = payload.pinMessageId;
            }*/
        };

        this[mutationTypes.CHAT_UPDATE_NICKNAME] = (state, payload) => {
            state.nickName = payload.nickName;
        };
        
        this[mutationTypes.CHAT_UPDATE_HEAD_IMAGE] = (state, payload) => {
            state.headImage = payload.headImage;
        };
    }

    getRoomName(type, name, members) {
        switch (type) {
            case CONSTANT.roomType.SYSTEM:
                return "系统讯息";
            case CONSTANT.roomType.CUSTOMER_SERVICE:
                return "在线客服";
            case CONSTANT.roomType.ANCESTOR:
                return members[0].loginId;
            case CONSTANT.roomType.DESCENDANT:
                return members[0].loginId
                    + (members[0].nickName ? ` (${members[0].nickName})` : "");
            default:
                return name;
        }
    }

    getMessageName(state, room, member, isMyself, name) {
        if (room.type === CONSTANT.roomType.SITE_GROUP || room.type === CONSTANT.roomType.SITE_GROUP_TUTOR) {
            return name;
        } else if (isMyself) {
            return this.getMessageNameMySelf(state);
        } else {
            if (member) {
                return this.getMessageNameOthers(room, member);
            }
        }
        return name;
    }

    getMessageNameMySelf(state) {
        return state.nickName ? state.nickName : state.loginId;
    }

    getMessageNameOthers(room, member) {
        switch (room.type) {
            case CONSTANT.roomType.ANCESTOR:
                return member.loginId;
            default:
                return member.nickName ? member.nickName : member.loginId;
        }
    }

    getHeadImage(state, member, isMyself, headImage) {
        return headImage;
    }

    updateLastMessage(state, roomId, userId, type, name, content, timestampStr) {
        let room = state.rooms.find((item) => item.id === roomId);
        let memberContainer = state.roomMemberContainers.find((item) => item.room.id === roomId);
        let member = (memberContainer && memberContainer.roomMembers) ?
            memberContainer.roomMembers.find((item) => item.userId === userId) : undefined;
        let isMyself = userId === state.userId;
        let timestamp = new Date(timestampStr);

        var newModel = new model.roomLastMessage({
            room: room,
            userId: userId,
            name: this.getMessageName(state, room, member, isMyself, name),
            type: type,
            content: content,
            timestamp: timestamp,
        });
        
        let index = state.roomLastMessages.findIndex((item) => item.room.id === roomId);
        if (index >= 0) {
            state.roomLastMessages.splice(index, 1);
        }
        
        // 用Object.freeze是為了減少loading時間, 頁面不能修改Object內的值
        state.roomLastMessages.push(Object.freeze(newModel));
    }

    addRoom(state, room, members, lastMessage) {
        // 如果已有聊天室就不新增
        const existedRoom = state.rooms.find((item) => item.id === room.id);
        if (existedRoom) {
            return;
        }

        // room跟群聊roomMember移除禁聊的成員
        if (state.excludeIsChatDenied) {
            if (room.type === CONSTANT.roomType.DESCENDANT) {
                if (members[0].isChatDenied) {
                    // 下級用戶已被禁言就不新增
                    return;
                }
            } else if (room.type === CONSTANT.roomType.DESCENDANT_GROUP) {
                // 群聊移除禁言成員
                members = members.filter(member => !member.isChatDenied);
            }
        }

        // 客服使用外接聊天室就不會出現未讀訊息
        if (room.type === CONSTANT.roomType.CUSTOMER_SERVICE && state.hasChatExternalLink) {
            room.unreadCount = 0;
        }

        // 設定聊天室名稱
        room.name = this.getRoomName(room.type, room.name, members);

        state.rooms.push(room);
        state.roomMemberContainers.push(new model.roomMemberContainer({
            room: room,
            roomMembers: members,
        }));
        
        // 新增的下級用戶加入預設的分類
        this.addDescendantRoomListClassification(state, room);

        // 設定最後一則訊息
        if (lastMessage) {
            this.updateLastMessage(state,
                lastMessage.roomId,
                lastMessage.userId,
                lastMessage.type,
                lastMessage.name,
                lastMessage.content,
                lastMessage.timestamp);
        }
    }

    addDescendantRoomListClassification(state, room) {
        if (room.type !== CONSTANT.roomType.DESCENDANT) {
            return
        }

        // 目前只會把所有下級放在一個下級的預設群組
        let roomListClassification = state.roomListClassifications
            .find((item) => item.roomType === CONSTANT.roomType.DESCENDANT);

        if (!roomListClassification) {
            roomListClassification = new model.roomListClassification({
                roomType: CONSTANT.roomType.DESCENDANT,
                rooms: []
            });
            state.roomListClassifications.push(roomListClassification);
        }
        
        roomListClassification.rooms.push(room);
    }
}
